// helpers/rutaProveedores.js
import axios from "axios";

// SIN slash final (y por las dudas lo quito)
const RAW_BASE_URL = import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, "");

const API = axios.create({ baseURL: BASE_URL });

// arma paths sin doble slash (y sin slash al inicio)
const p = (s) => String(s || "").replace(/^\/+/, "");

// headers con token si existe
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// DEBUG: ver URL efectiva
const debugUrl = (url) => console.log("👉 URL:", API.getUri({ url }));

// ---- PROVEEDORES ----
export const getProveedores = async () => {
  const url = p("proveedores");
  debugUrl(url);
  const { data } = await API.get(url, auth());
  // Normaliza: { ok, proveedores:[...] } o array directo
  return Array.isArray(data?.proveedores) ? data.proveedores : (Array.isArray(data) ? data : []);
};

export const getProveedorById = async (id) => {
  const url = p(`proveedores/${id}`);
  debugUrl(url);
  const { data } = await API.get(url, auth());
  return data; // típicamente { ok:true, proveedor:{...} }
};

export const postProveedor = async (payload) => {
  const url = p("proveedores");
  debugUrl(url);
  const { data } = await API.post(url, payload, auth());
  return data;
};

export const putProveedor = async (id, payload) => {
  const url = p(`proveedores/${id}`);
  debugUrl(url);
  const { data } = await API.put(url, payload, auth());
  return data;
};

export const deleteProveedor = async (id) => {
  const url = p(`proveedores/${id}`);
  debugUrl(url);
  const { data } = await API.delete(url, auth());
  return data;
};
